import Vue from 'vue';
import {ElementTiptapPlugin} from 'element-tiptap';
import 'domovio-core/src/system/sentry/init';
import App from '@/App.vue';
import router from '@/router';
import $store from 'domovio-core/src/system/store';
import {registerVueFilters} from 'domovio-core/src/system/filters';
import 'domovio-core/src/system/directives';

import {registerStoreModules} from '@/store';
import {registerMediaModule, registerUserModule} from 'domovio-core/src/system/store/registerModule';

import 'element-ui/lib/theme-chalk/dialog.css';
import 'element-ui/lib/theme-chalk/tooltip.css';
import 'element-ui/lib/theme-chalk/dropdown.css';

import CoreRegister from 'domovio-core/src/register';

const register = new CoreRegister();

Vue.use(ElementTiptapPlugin);

registerVueFilters();
registerStoreModules();
registerMediaModule();
registerUserModule();

register.registerModal();
register.registerVuelidate();
register.registerVueSelect();
register.registerNotifications();
register.registerAuthorization();

Vue.config.productionTip = false;

new Vue({
    router,
    store: $store,
    render: h => h(App)
}).$mount('#app');
